import {
  buildStorefrontAppearanceCss,
  normalizeStorefrontAppearanceSettings,
} from "../../lib/settings/storefront-appearance-settings";
import type { StorefrontAppearanceStoredValue } from "../../lib/settings/storefront-appearance-settings";
import type { PublicSettings } from "./public-settings";

const STYLE_ELEMENT_ID = "storefront-color-system";

function ensureAppearanceStyleElement(): HTMLStyleElement {
  const existing = document.getElementById(STYLE_ELEMENT_ID);
  if (existing instanceof HTMLStyleElement) {
    return existing;
  }
  const style = document.createElement("style");
  style.id = STYLE_ELEMENT_ID;
  style.dataset.storefrontColorSystem = "true";
  document.head.appendChild(style);
  return style;
}

export function applyStorefrontAppearanceToDocument(input: unknown): void {
  const normalized = normalizeStorefrontAppearanceSettings(input);
  const css = buildStorefrontAppearanceCss(input);
  const existing = document.getElementById(STYLE_ELEMENT_ID);
  if (!css) {
    existing?.remove();
    return;
  }
  ensureAppearanceStyleElement().textContent = css;
  if (normalized && "version" in normalized) {
    document.documentElement.dataset.colorMode = normalized.mode;
    document.body?.setAttribute("data-color-mode", normalized.mode);
  }
}

export function readStorefrontAppearanceFromPublicSettings(
  publicSettings: PublicSettings | null,
): StorefrontAppearanceStoredValue {
  return normalizeStorefrontAppearanceSettings(
    publicSettings?.storefrontAppearanceSettings,
  );
}
